<scib-app-wrapper>
	<scib-mf-dev-header header></scib-mf-dev-header>
	<router-outlet main></router-outlet>
</scib-app-wrapper>
